import "./components/bab-chart-app";
import { registerSW } from 'virtual:pwa-register';

registerSW({ immediate: true });
